const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 25,
		preventSortOfField: {
			tags: true,
			langCode: true,
			title: true,
			subTitle: true,
			path: true,
		},
		renderEmptyBeforReady: false,
		showHead: false,
		showInsertButton: false,
		showColorCodedRows: true,
		showAllBorders: false,
		showDelimiterBorders: true,
		inline: true,
		maxNrOfExportElements: 500000,
		rowActionsProperties: {
			colWidth: '42px'
		},
		rowActions: {
			delete: true
		},
		dynamicRowsByMainRowIndex: {
			1: 'entityPartsByLangCode',
		},
		entityTabOptions: { // stores properties used as tabOptions within resourceRegisterContents on showEdit() calls.
			// icon: 'fi fi-gear', // e.g., icon to use within tab of a newly opened entity.
		},
		showIDs: true, // ninja table columns don't line up nicely without the id column.
		refreshSelectionTargetResourcesOnSelectionChange: true, // some config.isSelectionTarget = true components has to refresh their resources to be able to show the data
		useSelectionObjectFormat: true,
	},

	model: {
		actionInEffect: '',
		actionModeInEffect: '',
		postProcessingOptions: {},
		// resourceFilters: {},
	},

	methods: {

		sanitizeResourceFilters(storage, resourceFilters, actionKey, areBaseTableResourceFilters){
			if(actionKey === 'loadComponentModelFieldsByNinjaCodeName'){
				for(const filterKey in resourceFilters || {}){
					delete resourceFilters[filterKey]
				}
			} else if(actionKey === 'refreshResources'){
				if(this.model.isInPicker === undefined){
					this.model.isInPicker = false
					this.closest('base_form_fields_ninja-picker-button', pickerButton => {
						this.model.isInPicker = true
						this.model.selectedRowIDs = pickerButton.model.dataJSON || {}
					})
				}

				resourceFilters = resourceFilters || {}
				resourceFilters.baseFilters = resourceFilters.baseFilters || {}
				resourceFilters.filters 	= resourceFilters.filters || {}

				// initialize selectedRows and other id lists if necessary.
				// this may be the case if the components resources are dependent on these ids.
				// e.g., subPicker-selectionTarget-table which has to load the records previously picked according to the given entityID-Selection.
				// the dataDealer would usually handle such cases but resourceFilters may be needed long before the dataDealer is called.
				if(this.config.isSelectionSource || this.config.isSelectionTarget){
					this.updateListOfIDs()
				}

				if(this.config.isSelectionSource){
					if(utils.collectionSize(this.model.blackListedRowIDs) > 0){
						resourceFilters.baseFilters.blackListedRowIDs = this.model.blackListedRowIDs
					} else {
						resourceFilters.baseFilters.blackListedRowIDs = []
					}
				}

				if(this.config.isSelectionTarget){
					if(utils.collectionSize(this.model.selectedRowIDs) > 0){
						resourceFilters.baseFilters.listOfPrimaryKeys = this.model.selectedRowIDs
					} else {
						resourceFilters.baseFilters.listOfPrimaryKeys = []
					}
				} else if(this.config.isSelectionSource) {
					if(resourceFilters.filters.showSelectionOnly && utils.collectionSize(this.model.selectedRowIDs) > 0){
						resourceFilters.filters.listOfPrimaryKeys = this.model.selectedRowIDs
					} else {
						delete resourceFilters.filters.listOfPrimaryKeys
					}
				}
			}
		},

		onResourceSanitized(){
			if(this.config.isSelectionTarget){
				// correct order of selected entities
				const entityList = this.model.entityList
				const orderedEntityList = {}
				const orderedEntityListByIndex = []
				let entityKey, rowIndex, rowID
				for(rowIndex in this.model.selectedRowIDs || []){
					rowID = this.model.selectedRowIDs[rowIndex]
					entityKey = `entityID_${rowID}`
					if(entityList[entityKey]){
						entityList[entityKey].index = rowIndex
						orderedEntityList[entityKey] = entityList[entityKey]
						orderedEntityListByIndex[rowIndex] = entityList[entityKey]
					}
				}

				this.model.entityList = orderedEntityList
				this.model.entityListByIndex = orderedEntityListByIndex
			}
		},

		sanitizeEntity(refEntity){
			if(this.config.usage === 'selection' && this.config.isSelectionSource){
				refEntity.selected = utils.indexOf(this.model.selectedRowIDs, refEntity.attributes[refEntity.primaryKey || 'id']) > -1
			}
		},

		updateListOfIDs: function(){
			if(!this.model.selectedRowIDInitialized){
				this.model.selectedRowIDInitialized = true;
				this.model.selectedRowIDs = utils.simpleCopy(this.getResourceRegisterContent('selectedRowIDs') || this.model.selectedRowIDs || []);
				this.model.blackListedRowIDs = utils.simpleCopy(this.getResourceRegisterContent('blackListedRowIDs') || this.model.blackListedRowIDs || []);
			}
		},

		addEntity: function(entity){
			// add entity to dom if possible
			if(this.config.isReady && (this.model.$table || []).length > 0){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }))
			}
		},

		async getResourceRegister(isInsert = false){
			// NOTE: overwrite if necessary
			return {}
		},

		async showInsert(rowID, rowData, buttonMode){
			const resourceRegister = await this.getResourceRegister(true)
			return this.performAndStoreAction(
				'showInsert_inEffect',
				this.prepareAction('showInsert', undefined, resourceRegister)
			)
		},

		async showEdit(rowID, rowData, buttonMode){
			if(!rowID){
				throw new ClientError('NINJA_MISSING_ROW_ID')
			}

			if(this.config.usage === 'selection'){
				if(this.config.isSelectionSource && this.model.controller){
					this.model.controller.toggleRowSelection(rowID, rowData);
				}
				return
			}

			let entityPrefix = ''
			if(this.hasRoleOption('showIDs')){
				entityPrefix = '#' + rowID + ' - ' + entityPrefix
			}
			const baseActionKey = 'showEdit'
			const actionKey = baseActionKey + '_' + rowID
			const rowAttributes = (rowData || {}).attributes || {}

			// estimate right title for this entity
			const {
				default: 	defaultLangCode,
				available: 	langs,
			} = utils.language.getConfig(storage)
			const langCodes = Object.keys(langs || {})
			const usedLangCode = storage.langCode
			const firstLangCode = langCodes[0]

			let title = rowAttributes.title || 'Unknown'
			for(const langCode of [usedLangCode, defaultLangCode, firstLangCode].concat(langCodes)){
				if(langCode && langs[langCode] && ((rowAttributes.entityPartsByLangCode || {})[langCode] || {}).title) {
					title = rowAttributes.entityPartsByLangCode[langCode].title
					break
				}
			}

			// re-perform action if necessary
			if(this.actions[actionKey]){
				return this.performAction(actionKey)
			}
			else if(this.actions[baseActionKey]){
				return this.performAndStoreAction(
					actionKey,
					this.prepareAction(baseActionKey, undefined, {
						entityParent: utils.replace(rowData, { resourceID: rowID }),
						tabOptions: {
							...(this.config.entityTabOptions || {}),
							title: entityPrefix + title,
						},
						...(await this.getResourceRegister()),
					}),
					false
				)
			}

			return utils.promise.reject()
		},

		async delete(rowID, rowData, buttonMode){
			if(rowID){
				const {decision = {}} = await this.performDecision(
					'confirm',
					{
						component:  this,
						title:      storage.__(`ninjaModules.${this.model.ninjaModule || 'missingNinjaModule'}.hint.delete.really.title`),
						message:    storage.__(`ninjaModules.${this.model.ninjaModule || 'missingNinjaModule'}.hint.delete.really.message`),
					}
				)

				if (decision.type === 'yes') {
					const context = await this.performAction(
						this.prepareAction('delete', rowID)
					)
					// refresh entity list
					this.refreshData()
					this.callHandler('onDeleteNinjaEntity', [rowID])
					return context
				}

				return utils.promise.reject()
			}

			return utils.promise.reject(new Error('DELETE NINJA ENTITY PRIMARY KEY MISSING'))
		},

		handleError: function(context){
			const baseError = utils.extractBaseError(context.error)

			// entity entry could not be loaded since it is missing
			if(
				((context || {}).component || {}).componentClass === 'templates_ninja_propertiesForm' &&
				baseError.statusCode === 404 &&
				baseError.errorCode === 'REQUEST_HANDLER_RESOURCE_NOT_FOUND_ERROR_2'
			){
				// prevent multiple error messages from being shown at once.
				this.skipFurtherErrorHandling()
				this.refreshData(true)
				return this.performAction(
					this.prepareAction('message', undefined, {
						messageDisplay: {
							message: `error:ninjaModules.${this.model.ninjaModule || 'missingNinjaModule'}.table.showEdit.missingEntry`,
						}
					}, {
						rollbackContext: context,
						statusControllerLoadingMessage: '',
						statusControllerSavingMessage:  ''
					})
				)
			}

			// routeContentTree of route could not be loaded since it is missing
			if(
				((context || {}).component || {}).componentClass === 'templates_routeContentTrees_routeContentTrees' &&
				baseError.statusCode === 404 &&
				baseError.errorCode === 'COMPONENT_TREE_BUILDER_ERROR_7'
			){
				// prevent multiple error messages from being shown at once.
				this.skipFurtherErrorHandling()
				this.refreshData(true)
				return this.performAction(
					this.prepareAction('message', undefined, {
						messageDisplay: {
							message: `error:ninjaModules.${this.model.ninjaModule || 'missingNinjaModule'}.table.showEdit.missingRoute`,
						}
					}, {
						rollbackContext: context,
						statusControllerLoadingMessage: '',
						statusControllerSavingMessage:  ''
					})
				)
			}

			context.errorUnhandled = true
			return utils.promise.resolve(context)
		},

		sourceSelectionChanged: function(){
			if(this.model.isInPicker && this.config.isSelectionSource){
				if(this.config.isMultiSelect){
					this.triggerClosest('onTableSelectionChanged', { selectedRowIDs: this.getSelectedRowIDs(true) })
				} else {
					this.triggerClosest('onDecision',  {
						decisionType: 				'submit',
						decisionComponent: 			this,
						decisionOptions: 			{
							mode: 	'useSelected',
						},
						decisionOrigin: 			this.getResourceRegisterContent('decisionOrigin', false) || {},
						decisionTriggerComponent: 	this,
					}, 'base_form_fields_ninja-picker-button')
				}
			}
		},

		selectionChanged: function(){
			if(this.model.isInPicker){
				this.triggerClosest('onChildChanged', {
					value: this.getSelectedRowIDs()
				});
			}
		},

		customClickHandler: function(event){
			const bubble = $(event.target).closest('.bubble')
			if(bubble.length > 0){
				const tagKey = bubble.data('tagKey')
				const tagParts = String(tagKey || '').split('_') || []
				const categoryID = tagParts[0] || 0
				const categoryDataID = tagParts[1] || 0
				if(categoryID && categoryDataID){
					this.triggerClosest('colTagsBubbleSelected', {
						categoryID,
						categoryDataID
					}, 'templates_ninja_controller')
					return true
				}
			}

			return false
		},

		onAfterLazyLoad: function(errorOccurred){
			if(!errorOccurred){
				this.updateBubbleHighlighting()
			}
		},

		updateBubbleHighlighting: function(){
			const highlightTagBubbles = ((this.model.resourceFilters || {}).filters || {}).tags || []
			this.$.find('.bubble').removeClass('highlighted')
			if(highlightTagBubbles.length > 0){
				this.$.find(highlightTagBubbles.map(tagKey => `.bubble[data-tag-key="${tagKey}"]`).join(',')).addClass('highlighted')
			}
		},

		onBeforeRender(){
			if(!this.model.controller){
				this.closest('templates_ninja_controller', controller => {
					this.model.controller = controller
					this.model.ninjaModule = this.config.buttonContext = controller.model.ninjaModule
				}, true)
			}
		},
	},

	hooks: {
		_attach: function($element, options){
			this.updateBubbleHighlighting()
		},

		async onDecision($element, options){
			if(options.decisionComponent.hasClass('base_modal_modal')){
				if(options.decisionType === 'cancel'){
					options.decisionComponent.hide()
				} else if(options.decisionComponent.hasClass('container_templates_ninja_propertiesForm')){
					options.decisionComponent.find('templates_ninja_propertiesForm', async propertiesForm => {
						const result = await propertiesForm.submit()
						const data = ((result || {}).response || {}).data || {}
						const attributes = data.attributes || {}
						const _primaryKey = attributes[data.primaryKey || 'id']

						await options.decisionComponent.hide()
						this.refreshData()

						if(_primaryKey){
							this.showEdit(_primaryKey, data)
						}
					})
				}
			}
		}
	},

	handlers: [{
		name: 'onSubmitDone',
		componentClass: 'templates_ninja_partPropertiesForm',
		handle: function(callerComponent, nodeData, insertPerformed){
			if(callerComponent.model.ninjaModule === this.model.ninjaModule){
				this.refreshData()
			}
		}
	},{
		name: 'onSubmitDone',
		componentClass: 'templates_ninja_propertiesForm',
		handle: function(callerComponent, nodeData, insertPerformed){
			if(callerComponent.model.ninjaModule === this.model.ninjaModule){
				this.refreshData()
			}
		}
	}]
}
